import { apiConfig } from "../../configs/app";
import Product from "../../types/product.type";
import CryptoService from "../crypto.services";

type ApiSkuPriceRange = Product["sku_price_range"]
type ApiProduct = Omit<Product, "sku_price_range" | "sku_price_scale"> & {
    sku_price_range?: ApiSkuPriceRange
    sku_price_scale?: string
    tiered_price_info?: {
        begin_num?: number | string
        prices?: {
            beginAmount: string
            price: string
        }[]
    }
}
type ApiResponse = {
    code: number
    data: ApiProduct
}

function buildSkuPriceScale(product: ApiProduct) {
    if (product.sku_price_scale) {
        return product.sku_price_scale
    }
    const min = product.price_info?.price_min
    const max = product.price_info?.price_max
    if (min && max) {
        return min === max ? `￥${min}` : `￥${min}-￥${max}`
    }
    return ""
}

function normalizeProduct(product: ApiProduct): Product {
    const tieredPrices = product.tiered_price_info?.prices || []
    const beginNumFromTier = product.tiered_price_info?.begin_num
    const fallbackSkuPriceRange: ApiSkuPriceRange = {
        begin_num: String(beginNumFromTier || tieredPrices[0]?.beginAmount || 1),
        stock: Number(product.stock || 0),
        sell_unit: product.unit || "",
        skuPriceType: undefined,
        sku_param: tieredPrices,
        mix_param: null
    }

    return {
        ...product,
        sku_price_scale: buildSkuPriceScale(product),
        sku_price_range: product.sku_price_range || fallbackSkuPriceRange
    } as Product
}

function getKey(productId: string){
    return CryptoService.hash('product-data-' + productId)
}
export function getLocalProduct(productId: string) {
    const localStorageKey = getKey(productId)
    const localData = window.localStorage.getItem(localStorageKey)
    if (!localData) {
        return null
    }
    const response = JSON.parse(CryptoService.decrypt(localData)) as ApiResponse
    return {
        ...response,
        data: normalizeProduct(response.data)
    }
}
export function fetchProduct(productId: string) {
    const localStorageKey = getKey(productId)
    let promise:Promise<Response>
    promise = fetch(apiConfig.products + '/' + productId )
    return promise.then((res) => res.json())
        .then((res:ApiResponse) => {
            if (res.data.item_id) {
                const normalizedRes = {
                    ...res,
                    data: normalizeProduct(res.data)
                }
                window.localStorage.setItem(localStorageKey, CryptoService.encrypt(JSON.stringify(normalizedRes)))
                return normalizedRes
            } else {
                return null
            }
        })
}
